<template>
  <div>
    <div style="width:100%;">
      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>
<script>
  import '@/services/components/ScoreChart/Chart.min.js';
  import '@/services/components/ScoreChart/utils.js';
  export default {

    mounted() {
      var MONTHS = ["Q3 2019", "Q1 2020", "Q3 2020", "Q1 2021", "Q3 2021"];
      var config = {
        type: "line",
        data: {
          labels: ["Q3 2019", "Q1 2020", "Q3 2020", "Q1 2021", "Q3 2021"],
          //labels: ["Q9 2019"],
          datasets: [
            {
              label: "Brazil",
              backgroundColor: window.chartColors[0],
              borderColor: window.chartColors[0],
              lineTension: 0,
              data: [
                randomScalingFactor(0),
                randomScalingFactor(0),
                randomScalingFactor(0),
                randomScalingFactor(0),
                randomScalingFactor(0),
                randomScalingFactor(0),
                randomScalingFactor(0)
              ],
              fill: false
            },
            {
              label: "Canada",
              fill: false,
              backgroundColor: window.chartColors[1],
              borderColor: window.chartColors[1],
              lineTension: 0,
              data: [
                randomScalingFactor(1),
                randomScalingFactor(1),
                randomScalingFactor(1),
                randomScalingFactor(1),
                randomScalingFactor(1),
                randomScalingFactor(1),
                randomScalingFactor(1)
              ]
            },
            {
              label: "Egypt",
              backgroundColor: window.chartColors[2],
              borderColor: window.chartColors[2],
              lineTension: 0,
              data: [
                randomScalingFactor(2),
                randomScalingFactor(2),
                randomScalingFactor(2),
                randomScalingFactor(2),
                randomScalingFactor(2),
                randomScalingFactor(2),
                randomScalingFactor(2)
              ],
              fill: false
            },
            {
              label: "India",
              fill: false,
              backgroundColor: window.chartColors[3],
              borderColor: window.chartColors[3],
              lineTension: 0,
              data: [
                randomScalingFactor(3),
                randomScalingFactor(3),
                randomScalingFactor(3),
                randomScalingFactor(3),
                randomScalingFactor(3),
                randomScalingFactor(3),
                randomScalingFactor(3)
              ]
            },
            {
              label: "Spain",
              backgroundColor: window.chartColors[4],
              borderColor: window.chartColors[4],
              lineTension: 0,
              data: [
                randomScalingFactor(4),
                randomScalingFactor(4),
                randomScalingFactor(4),
                randomScalingFactor(4),
                randomScalingFactor(4),
                randomScalingFactor(4),
                randomScalingFactor(4)
              ],
              fill: false
            }
          ]
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "CTC compliance index"
          },
          tooltips: {
            mode: "index",
            intersect: false
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Period"
                }
              }
            ],
            yAxes: [
              {
                ticks: { beginAtZero: true },
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Score"
                }
              }
            ]
          }
        }
      };

      window.onload = function () {
        var ctx = document.getElementById("canvas").getContext("2d");
        window.myLine = new Chart(ctx, config);
      };

      //document
      //  .getElementById("randomizeData")
      //  .addEventListener("click", function () {
      //    config.data.datasets.forEach(function (dataset) {
      //      dataset.data = dataset.data.map(function () {
      //        return randomScalingFactor();
      //      });
      //    });

      //    window.myLine.update();
      //  });

      //var colorNames = Object.keys(window.chartColors);
      //document
      //  .getElementById("addDataset")
      //  .addEventListener("click", function () {
      //    var colorName =
      //      colorNames[config.data.datasets.length % colorNames.length];
      //    var newColor =
      //      window.chartColors[config.data.datasets.length % colorNames.length];

      //    var newDataset = {
      //      label: "Dataset " + config.data.datasets.length,
      //      backgroundColor: newColor,
      //      borderColor: newColor,
      //      lineTension: 0,
      //      data: [],
      //      fill: false
      //    };

      //    for (var index = 0; index < config.data.labels.length; ++index) {
      //      newDataset.data.push(
      //        randomScalingFactor(config.data.datasets.length)
      //      );
      //    }

      //    config.data.datasets.push(newDataset);
      //    window.myLine.update();
      //  });

      //document.getElementById("addData").addEventListener("click", function () {
      //  if (config.data.datasets.length > 0) {
      //    var month = MONTHS[config.data.labels.length % MONTHS.length];
      //    config.data.labels.push(month);

      //    config.data.datasets.forEach(function (dataset, i) {
      //      dataset.data.push(randomScalingFactor(i));
      //    });

      //    window.myLine.update();
      //  }
      //});

      //document
      //  .getElementById("removeDataset")
      //  .addEventListener("click", function () {
      //    config.data.datasets.splice(0, 1);
      //    window.myLine.update();
      //  });

      //document
      //  .getElementById("removeData")
      //  .addEventListener("click", function () {
      //    config.data.labels.splice(-1, 1); // remove the label first

      //    config.data.datasets.forEach(function (dataset) {
      //      dataset.data.pop();
      //    });

      //    window.myLine.update();
      //  });
    }
  }
</script>
<style>

  canvas {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
</style>
